import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar";

import { useNavigate, useParams } from "react-router-dom";
import "./style.css";
import { useAuthContext } from "../../hooks";
import { getOrgUsersProjects } from "../../api/project/getOrgUserProjects";
import ProjectsSc from "./index.sc";
function Index() {
  const navigate = useNavigate();
  const auth = useAuthContext();
  const [userProjects, setUserProjects] = useState<any[]>([]);
  const params = useParams();
  const fetchOrguserProjects = async () => {
    await getOrgUsersProjects(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString()
    )
      .then((e) => {
        console.log(e);
        setUserProjects(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchOrguserProjects();
  }, []);

  return (
    <ProjectsSc>
      <div className="overall-project-container">
        {userProjects.length > 0 ? (
          userProjects?.map((data) => {
            return (
              <>
                <div
                  className="project-card"
                  onClick={() => navigate(`${data?.ProjectId}`)}
                >
                  <div className="project-card-heading">
                    <p>{data?.ProjectName}</p>
                    <p>View Project</p>
                  </div>
                  <div>{data?.description}</div>
                  <hr />
                </div>
              </>
            );
          })
        ) : (
          <div>
            {auth?.userInfo?.first_name} you dont have any assigned projects,
            management willl assign you the projects{" "}
          </div>
        )}
      </div>
    </ProjectsSc>
  );
}

export default Index;
